import React from 'react';
import { Space } from 'antd';
import { ActionButton, ResponsiveModal } from '../styled';

const CredentialsModal = ({
  credentialsModal,
  onCopyCredentials,
  onClose
}) => {
  return (
    <ResponsiveModal
      title="User Credentials"
      open={credentialsModal.visible}
      onCancel={() => onClose()}
      footer={null}
      width={400}
    >
      <p><strong>Email:</strong> {credentialsModal.userEmail}</p>
      <p><strong>Temporary Password:</strong> {credentialsModal.tempPassword}</p>
      <p style={{ color: 'red' }}>
        Please make sure to change the password after the first login.
      </p>
      <Space>
        <ActionButton
          type="primary"
          onClick={onCopyCredentials}
        >
          Copy Credentials
        </ActionButton>
        <ActionButton
          onClick={onClose}
        >
          Close
        </ActionButton>
      </Space>        
    </ResponsiveModal>
  );
};

export default CredentialsModal;
